<template>
  <b-modal id="modal-review" size="xl">
    <!--Content-->
    <template slot="modal-header">
      <div class>
        <!--Header-->
        <div>{{ EntityTypeString }}</div>
      </div>
    </template>

    <!--Body-->
    <div class="modal-body">
      <SeminarReview review_type="Counts" :seminar_object="current_seminar" />
    </div>

    <!--Footer-->
    <template slot="modal-footer">
      <div
        slot
        class="modal-footer justify-content-center"
        style="border: none"
      >
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="outline-primary"
          data-dismiss="modal"
          @click="$bvModal.hide('modal-review')"
          aria-label="Close"
          >Cancel</b-button
        >
        <a
          type="button"
          class="btn btn-primary text-white"
          @click="transmitRequest"
        >
          Send
          <i class="fa fa-envelope ml-1 text-white"></i>
        </a>
      </div>
    </template>

    <!--/.Content-->
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SeminarReview from "@/components/CustomSubComponents/SeminarReview.vue";
export default {
  components: { SeminarReview },
  computed: {
    ...mapState(["n_user", "seminar"]),
    ...mapActions("n_user", ["Delete"]),
    ...mapActions("dealership", ["Delete"]),
    ...mapActions("campaign", ["Delete"]),
    EntityTypeString() {
      return this.EntityType;
    },
  },
  data() {
    return {
      current_seminar: this.seminar_object,
      StatusTypeInt: this.StatusType,
    };
  },
  created() {},
  watch: {
    EntityTypeString() {
    },
  },
  mounted() {},
  methods: {
    transmitRequest: function () {
      this.$store
        .dispatch("seminar/Notify", {
          seminar: {SeminarID: this.current_seminar.SeminarID},
          type: this.StatusType,
        })
        .then(this.$bvModal.hide("modal-review"));
    },
  },
  props: {
    seminar_object: { type: Object },
    EntityType: "",
    StatusType: 0,
  },
  updated() {},
};
</script>
